import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import DirectoryPage from './pages/DirectoryPage';
import PlayerPage from './pages/PlayerPage';
import PasswordGate from './components/PasswordGate';
import './App.css';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isChecking, setIsChecking] = useState(true);

  // Check if user is already authenticated (from sessionStorage)
  useEffect(() => {
    const authenticated = sessionStorage.getItem('isocentral_authenticated');
    if (authenticated === 'true') {
      setIsAuthenticated(true);
    }
    setIsChecking(false);
  }, []);

  const handleAuthenticated = () => {
    setIsAuthenticated(true);
  };

  // Show nothing while checking authentication
  if (isChecking) {
    return null;
  }

  // Show password gate if not authenticated
  if (!isAuthenticated) {
    return <PasswordGate onAuthenticated={handleAuthenticated} />;
  }

  // Show main app if authenticated
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<DirectoryPage />} />
          <Route path="/player/:playerId" element={<PlayerPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
